import { AllVariations } from '../type/AllVariations';
import { Variation } from '../interfaces/Variation';

class SortVariationsHelper {
  public static sortVariationsById(variations: Variation[]): Variation[] {
    return variations.sort((a, b) => b.id - a.id);
  };

  public static sortAllVariationsByDatetime(variations: AllVariations[]): AllVariations[] {
    return variations.sort((a, b) => new Date(b.attributes.createdAt).getTime() - new Date(a.attributes.createdAt).getTime());
  };
}

export default SortVariationsHelper
